import { Avatar, NotificationBadge, Spinner } from '@bphxd/ds-core-react'
import { UncontrolledDropdown, DropdownMenu, DropdownItem, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import './MainHeader.scss'
import { LogOut24 } from '@bphxd/ds-core-react/lib/icons'
import { IPublicClientApplication } from '@azure/msal-browser';
import { AuthenticatedTemplate, useIsAuthenticated, useMsal } from '@azure/msal-react';
import { useEffect, useState } from 'react';
import { useUser } from '../../contexts/userContextApi';
import Notification from './Notification';
export default function MainHeader() {
  const [userName, setUserName] = useState<any>('User');
  const { isAuthorize, isLoadingLandingPage, role } = useUser();
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  //const isAdmin = sessionStorage.getItem("isAdmin");
  //let auth = sessionStorage.getItem("isUnAuth");
  const tokenExpireTime = sessionStorage.getItem("tokenExpireTime");
  const toMilliseconds = (hrs: any, min: number, sec: number) => (hrs * 60 * 60 + min * 60 + sec) * 1000;
  //const tokenExpTime = toMilliseconds(0, parseInt(tokenExpireTime ? tokenExpireTime : "0"), 0);
  const tokenExpTime = 60 * 60 * 1000;
  const [sessionExpiry, setSessionExpiry] = useState(Number(sessionStorage.getItem("sessionExpiry")));//added by Gowthami 8 lines
  useEffect(() => {
    if (!isAuthenticated) return;

    const expiry = Date.now() + tokenExpTime;

    sessionStorage.setItem("sessionExpiry", expiry.toString());
    setSessionExpiry(expiry);
    setTimeLeft(Math.floor(tokenExpTime / 1000));
  }, [isAuthenticated]);
  const counters = sessionStorage.getItem("noiticationcount") || "0";
  const [timeLeft, setTimeLeft] = useState(60 * 60);
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    const remaining = sessionExpiry - Date.now();
    if (remaining > 0) {
      const timer = setTimeout(() => {
        setShowWarning(false);
        sessionStorage.clear();
        redirectSignOut(instance);
      }, remaining);
      return () => clearTimeout(timer);
    }
  }, [sessionExpiry]);

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }
    const interval = setInterval(() => {
      const remaining = Math.max(
        0,
        Math.floor((sessionExpiry - Date.now()) / 1000)
      );

      setTimeLeft(remaining);

      if (remaining === 60) {
        setShowWarning(true);
      }

      if (remaining <= 0) {
        clearInterval(interval);
        setShowWarning(false);
        sessionStorage.clear();
        redirectSignOut(instance);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [isAuthenticated, instance, sessionExpiry]);

  useEffect(() => {
    if (isAuthenticated) {
      if (accounts[0].idTokenClaims?.name?.length !== 0 || accounts[0].idTokenClaims?.name !== undefined) {
        setUserName(accounts[0].idTokenClaims?.name);
      }
    }
    else {
      setUserName('User');
    }
  }, [isAuthenticated, accounts]);

  const redirectSignOut = (instance: IPublicClientApplication) => {
    const logoutRequest = {
      postLogoutRedirectUri: window.location.origin,
    };

    sessionStorage.clear();
    instance.logoutRedirect(logoutRequest);
  };
  return (
    <div>
      <div style={{ display: 'block' }} className=''>
        <div className='main-header-logo-background main-header-logo'>
          <img
            className='main-header-logo-img'
            width="100%"
            height="100%"
            src='/images/castrol_logo.svg'
            alt='Castrol Logo'
          />
          <div className='main-header-text'>IT'S MORE THAN JUST OIL. IT'S LIQUID ENGINEERING</div>


          <AuthenticatedTemplate>
            <UncontrolledDropdown className="d-inline-flex ms-6 profile-field">

              {(role === 'tax_user') && <Notification />}

              {isAuthenticated && (
                <div
                style={{
                  //position: "fixed",
                  top: "20px",
                  right: "180px",
                  //zIndex: 99999,
                  //alignItems: "center",
                  color: "#ff0000",
                  fontWeight: "bold",
                  fontSize: "14px",
                  background: "transparent",
                  padding: "5px 30px",

                }}
                >
                  Your current session will expire within:{" "}
                  {Math.floor(timeLeft / 60)}:
                  {String(timeLeft % 60).padStart(2, "0")} minute
                </div>
              )}

              <Avatar size='sm' className="me-3" label="My Account" suffix dropdown />

              <DropdownMenu end>

                <DropdownItem disabled>
                  <span>Welcome{' '}{userName}</span>
                </DropdownItem>
                <DropdownItem disabled>
                  <span>Logged in as {role === "admin" ? "Admin" : role === "super_user" ? "Super User" : role === "itr_user" ? "Itr User" : role === "tax_user" ? "Tax User" : "User"}</span>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem onClick={() => redirectSignOut(instance)}>
                  <span><LogOut24 className='mx-3' color='#007f00' />Sign Out</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </AuthenticatedTemplate>
        </div>
      </div>
      {
        isLoadingLandingPage && (
          <div className="landing-loader">
            <Spinner color="brand" />
          </div>
        )
      }
      <Modal isOpen={showWarning} centered>
        <ModalHeader>Session Expiry Warning</ModalHeader>

        <ModalBody>Your session will expire in 1 minute.
          <br />
          Would you like to continue your session?
        </ModalBody>

        <ModalFooter>
          <Button
            color="primary"
            onClick={() => {
              setShowWarning(false);

              const newExpiry = Date.now() + tokenExpTime;

              sessionStorage.setItem("sessionExpiry", newExpiry.toString());
              setSessionExpiry(newExpiry);

              setTimeLeft(Math.floor(tokenExpTime / 1000));
            }}
          >
            Continue Session
          </Button>

          <Button
            color="primary"
            onClick={() => {
              setShowWarning(false);
            }}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  )
}